import React, { useEffect, useState } from "react";
import { HiArrowLeft } from "react-icons/hi";
import { HiTicket } from "react-icons/hi2";
import PayperviewService from "services/payperview/PayperviewServie";
import LoadingSpin from "./Loading spins/LoadingSpin";
import { useNavigate } from "react-router-dom";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  ppv_event: any;
}

const TicketVerificationModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  ppv_event,
}) => {
  const navigate = useNavigate();
  const slug = ppv_event?.slug;
  const [loading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    ticket: "",
  });
  const [errors, setErrors] = useState({
    ticket: [],
  });

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isOpen]);

  const onChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleVerifyButton = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    await PayperviewService.verifyEventTicket(formData)
      .then((response) => {
        if (response.status === 200) {
          resetForm();
          removeErrors();
          navigate("/ppv/watch/event/" + slug);
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 422) {
          const errorData = error.response.data.errors;
          setErrors(errorData);
        } else if (error.response.status === 404) {
          updateTicketError(["Invalid Ticket Entry"]);
        } else if (error.response.status === 403) {
          updateTicketError(["Maximum users limit reached for this ticket"]);
        } else {
          updateTicketError(["Something went wrong, Try again"]);
        }
        setLoading(false);
      });
  };

  const resetForm = () => {
    setFormData({
      ticket: "",
    });
  };

  const removeErrors = () => {
    setErrors({
      ticket: [],
    });
  };

  const updateTicketError = (error: any) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      ticket: error,
    }));
  };

  return isOpen ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="relative w-[420px] max-w-[90%] overflow-hidden rounded-2xl border border-white/10 bg-[#131313] p-8 shadow-2xl shadow-black/60">
        {/* subtle red glow accent in the corner, matching the app's glass-card language */}
        <div className="pointer-events-none absolute -top-24 -right-24 h-56 w-56 rounded-full bg-[var(--red)]/10 blur-3xl" />

        <button
          className="relative z-10 mb-6 flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-white backdrop-blur-sm transition-colors hover:bg-white/[0.08]"
          onClick={onClose}
        >
          <HiArrowLeft />
        </button>

        <form className="relative z-10">
          <div className="mb-6 flex items-center gap-2">
            <span className="h-3 w-[3px] bg-[var(--red)]" />
            <span className="text-xs font-semibold uppercase tracking-widest text-white/50">
              Pay Per View
            </span>
          </div>

          <h1 className="mb-2 text-2xl font-bold text-white">
            Ticket verification
          </h1>
          <p className="mb-6 text-sm leading-relaxed text-white/50">
            Enter the ticket code you received in your email when you
            purchased this event.
          </p>

          <div className="relative mb-2">
            <HiTicket className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-white/30" />
            <input
              type="text"
              placeholder="Enter your ticket"
              name="ticket"
              value={formData.ticket}
              onChange={onChange}
              autoComplete="off"
              className="h-[48px] w-full rounded-lg border border-white/10 bg-white/[0.05] pl-11 pr-4 text-sm text-white placeholder-white/30 outline-none backdrop-blur-sm transition-colors focus:border-[var(--red)]/60 [&:-webkit-autofill]:![-webkit-text-fill-color:white] [&:-webkit-autofill]:![-webkit-box-shadow:0_0_0_1000px_#1c1c1c_inset] [&:-webkit-autofill]:![transition:background-color_9999s_ease-in-out_0s]"
            />
          </div>

          {errors.ticket?.length > 0 && (
            <div className="mb-4 text-left">
              <span className="text-xs text-[var(--red)]">
                {errors.ticket[0]}
              </span>
            </div>
          )}

          {loading ? (
            <button className="mt-4 flex w-full items-center justify-center rounded-full bg-[var(--red)] py-3 shadow-lg shadow-[var(--red)]/30">
              <LoadingSpin fontSize={20} color={"white"} />
            </button>
          ) : (
            <button
              className="mt-4 flex w-full items-center justify-center rounded-full bg-[var(--red)] py-3 text-sm font-semibold text-white shadow-lg shadow-[var(--red)]/30 transition-transform hover:scale-[1.01] active:scale-[0.99]"
              onClick={handleVerifyButton}
            >
              Verify Now
            </button>
          )}
        </form>
      </div>
    </div>
  ) : null;
};

export default TicketVerificationModal;
